import React from 'react';
import Grid from '@mui/material/Grid2'
import { Box, IconButton } from '@mui/material';
import { MapSharp, TableChart } from '@mui/icons-material';
import { FielderHard } from '@core/theme/baseTheme';

const MyOperationHeaderTitle = ({ showMap, handleViewTable, handleViewIcon }) => {
  return (
    <Box sx={{ position: 'relative' }}>
      <Grid container />
      <Box
        sx={{
          position: 'absolute',
          top: 8,
          right: 8,
          display: 'flex',
          gap: 1,
          zIndex: (t) => t.zIndex.appBar + 1,
          pointerEvents: 'auto',
        }}
      >
        <IconButton
          size="small"
          onClick={handleViewTable}
          aria-label="Ver tabla" sx={{ color: showMap ? 'inherit' : FielderHard }}>
          <TableChart ></TableChart>
        </IconButton>
        <IconButton
          size="small"
          onClick={handleViewIcon}
          aria-label="Ver mapa"
          sx={{ color: showMap ? FielderHard : 'inherit' }}>
          <MapSharp ></MapSharp>
        </IconButton>
      </Box>
    </Box>
  );
}
export default MyOperationHeaderTitle;
